import { useContext, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deletePromiseAction, promisedToCollectionAction } from '../../../Redux/Action/AgentAction';
import { PromisedDonerHistoryContext } from '../PromisedDonerComponent';

function PromiseDeleteForm(props) {
    // Hook
    const dispatch = useDispatch()
    const btnRef = useRef()
    // Context
    const {
        promisedDonerHistory,
        setPromisedDonerHistory,
        promisedToCollectionModelShow,
        setPromisedToCollectionModelShow,
        promisedToCollectionSingle,
        setPromisedToCollectionSingle,
        setPromisedReload,
        setPromiseDeleteModal
    } = useContext(PromisedDonerHistoryContext)

    const submitHendeler = () => {

        const payload = {
            data: {
                promised_collection_id: promisedToCollectionSingle.id
            },
            setPromisedReload,
            setPromiseDeleteModal,
            btnRef
        }

        // action dispatch
        dispatch(deletePromiseAction(payload))
    }

    return (
        <>
            <div className='text-center'>
                <h4>Are you Sure ?</h4>
                <Button className='btn btn-sm btn-success mx-2' onClick={(e) => {
                    submitHendeler()
                }}>Yes</Button>

                <Button ref={btnRef} onClick={(e) => {
                    setPromiseDeleteModal(false)
                }} className='btn btn-sm btn-danger'>No</Button>
            </div>
        </>
    );
}

export default PromiseDeleteForm;